'use strict';

// Constructor
var Header = function() {
    var header = $('.header');
    var body = $('body');
    var menuOpen = $('.header__hamburguer');
    var submenu = $('.header__submenu');
    var submenuOpen = $('[data-content="submenu"]');

    submenuOpen.on('click', function(){
        submenu.addClass('-open');
    });

    menuOpen.on('click', function(){
        header.toggleClass('-open');
        body.toggleClass('-hideOverflow');
    });

    function detectLang() {
        var currentLang = $('html').attr('lang');
        var langClass = currentLang === 'es' ? '-esp' : '-eng';
        body.addClass(langClass);
    }

    detectLang();

    $(window).scroll(function() {
        if ($(this).scrollTop() > 50){
            $('header').addClass("sticky");
        }
        else{
            $('header').removeClass("sticky");
        }
    });

    $('#lang-selector').on('change', function(e) {
        var selectedLang = e.target.value;
        var url = selectedLang === 'esp' ? '/' : '/en';

        window.location.href = url;
    });

    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
        // On-page links
        if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
        ) {
        // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('html, body').animate({
                scrollTop: target.offset().top + -90
                }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                });
            }
        }
    });
};

module.exports = Header;
